import {Box, Stack, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import {Drawer} from 'presentation/components/Drawer';
import {HandleMessage} from 'presentation/components/HandleMessage';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {OnDemandExamDrawerProps} from './types';

const {onDemandExamDrawer} = translations['pt-br'].privateFlow.guideFlow;

export function OnDemandExamDrawer({
	open,
	specialtyName,
	hasExamPreparation,
	onOpen,
	onClose,
	onViewUnits,
}: OnDemandExamDrawerProps) {
	return (
		<Drawer.Root open={open} onOpen={onOpen} onClose={onClose}>
			<Drawer.Header title={onDemandExamDrawer.headerTitle} onClose={onClose} />
			<Drawer.Content sx={{overflow: 'visible'}}>
				<Stack mt={1.5} gap={2}>
					<Stack direction="row" gap={2}>
						<Box>
							<IconIllustration
								variant="primary"
								customIconName="query-builder-filled"
								size="smaller"
							/>
						</Box>
						<Box>
							<Typography variant="h6" fontSize="16px">
								{onDemandExamDrawer.freeDemand.title}
							</Typography>
							<Typography variant="body2" color="text.secondary">
								<HandleMessage
									message={onDemandExamDrawer.freeDemand.description}
									variables={[specialtyName]}
								/>
							</Typography>
						</Box>
					</Stack>
					<Stack direction="row" gap={2}>
						<Box>
							<IconIllustration
								variant="primary"
								customIconName="file-document-outline"
								size="smaller"
							/>
						</Box>
						<Box>
							<Typography variant="h6" fontSize="16px">
								{onDemandExamDrawer.requiredDocuments.title}
							</Typography>
							<Typography variant="body2" color="text.secondary">
								{onDemandExamDrawer.requiredDocuments.description}
							</Typography>
						</Box>
					</Stack>
					{hasExamPreparation ? (
						<Stack direction="row" gap={2}>
							<Box>
								<IconIllustration
									variant="primary"
									customIconName="assignment-outline"
									size="smaller"
								/>
							</Box>
							<Box>
								<Typography variant="h6" fontSize="16px">
									{onDemandExamDrawer.examPreparation.title}
								</Typography>
								<Typography variant="body2" color="text.secondary">
									<HandleMessage
										message={onDemandExamDrawer.examPreparation.description}
										variables={[specialtyName]}
									/>
								</Typography>
							</Box>
						</Stack>
					) : null}
				</Stack>
			</Drawer.Content>
			<Drawer.Footer
				canStacks
				firstButtonTitle={onDemandExamDrawer.backButton}
				firstButtonOnClick={onClose}
				secondButtonTitle={onDemandExamDrawer.viewUnitsButton}
				secondButtonOnClick={onViewUnits}
			/>
		</Drawer.Root>
	);
}
